import { render } from "./FeaturedPostSpotCard.vue?vue&type=template&id=c6fa9cda"
import script from "./FeaturedPostSpotCard.vue?vue&type=script&lang=js"
export * from "./FeaturedPostSpotCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__